import React from 'react';

const Sidebar = ({ onDocChange }) => {
  return (
    <div className="w-64 bg-blue-600 text-white h-full p-6">
      <h1 className="text-2xl font-semibold mb-8">Menú de Documentación</h1>
      <nav>
        <ul>
          <li className="mb-4">
            <button 
              onClick={() => onDocChange('doc1')}
              className="text-white hover:text-gray-300">
              Inicio
            </button>
          </li>
          <li className="mb-4">
            <button 
              onClick={() => onDocChange('doc2')}
              className="text-white hover:text-gray-300">
              Homologación
            </button>
          </li>
          <li className="mb-4">
            <button 
              onClick={() => onDocChange('doc3')}
              className="text-white hover:text-gray-300">
              Producción
            </button>
          </li>
          <li className="mb-4">
            <button 
              onClick={() => onDocChange('doc4')}
              className="text-white hover:text-gray-300">
              Información de ARCA
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
